module.exports = __webpack_public_path__ + "static/media/Mockup_weiss-1030x1030.26d33dad.png";